const headerHeight = () => {
	// full height vh without header height
	const header = document.querySelector(".header");

	if (header !== null) {
		document
			.querySelector("body")
			.style.setProperty("--header-height", header.clientHeight + "px");
	}

	const navSticky = document.querySelector(".sticky-submenu");
	if (navSticky !== null) {
		document
			.querySelector("body")
			.style.setProperty("--sticky-submenu", navSticky.clientHeight + "px");
	}
};

export default headerHeight;
